module.exports = __webpack_public_path__ + "media/functional__tony.1722dc24.mp4";